import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';
export { updateHostedApp } from './actions/updateHostedApp';
export { onOpenMOSAppWithContext } from './actions/onOpenMOSAppWithContext';
export { onInvalidAppNavigation } from './mutators/onInvalidAppNavigationMutator';
export { default as getIsInError } from './selectors/getIsInError';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "AppHostContainer" */ './lazyIndex')
);

export const AppHostContainer = createLazyComponent(lazyModule, m => m.AppHostContainer);
export const lazyTryOpenMOSAppWithContext = new LazyAction(
    lazyModule,
    m => m.tryOpenMOSAppWithContext
);

import './mutators/updateHostedAppMutators';
